import { Text } from "@overmap-ai/blocks"
import { type Form } from "@overmap-ai/common"
import { selectFormById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react"
import { memo } from "react"

import { useAppSelector } from "../../../../store"

export const FormMentionComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const { uuid } = node.attrs as { uuid: Form["uuid"] }

	const form = useAppSelector(selectFormById(uuid))

	return (
		<NodeViewWrapper
			className="bg-(--base-a3) py-0.25 inset-ring inset-ring-(--base-a6) rounded-md px-1 align-bottom"
			as="span"
		>
			{!!form && (
				<Link
					from="/$organizationId"
					to="/$organizationId/forms/$formId"
					params={(prev) => ({ ...prev, formId: form.uuid })}
				>
					<Text className="truncate">{form.name}</Text>
				</Link>
			)}
		</NodeViewWrapper>
	)
})
FormMentionComponent.displayName = "FormMentionComponent"
